import { render, staticRenderFns } from "./MyPersonalInfo.vue?vue&type=template&id=cbc05b5c&scoped=true&"
import script from "./MyPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./MyPersonalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc05b5c",
  null
  
)

export default component.exports